// @flow
import client from '../../client'
import buildGoogleLocation from './builders/googleLocation'

// Types
import type { DetailedPlaceResponse } from '../../api_types'
import type { SuggestionLocation } from '../../models/location'

export type PlaceCache = {
  [id: string]: Promise<SuggestionLocation>,
}

// Constants
export const PLACE_DETAILS_ENDPOINT = '/locations/details/'
let PLACE_CACHE: PlaceCache = {}

// Utils
export function resetPlacesCache() {
  PLACE_CACHE = {}
}

/**
 * Get a place details, including geo-location information.
 * @param  {string} placeId Place ID
 * @return @return {Promise|Error} A resolved Promise with place details or Rejected with an Error.
 */
export const getPlaceDetails = (
  placeId: string
): Promise<SuggestionLocation> => {
  if (!placeId) {
    return Promise.reject(new Error('Provided place id is empty'))
  }

  const cachedPlace = PLACE_CACHE[placeId]
  if (cachedPlace) return cachedPlace

  const result = client
    .get(PLACE_DETAILS_ENDPOINT, { query: { place_id: placeId } })
    .then((response: DetailedPlaceResponse): SuggestionLocation =>
      buildGoogleLocation(response.result)
    )

  PLACE_CACHE[placeId] = result
  return result
}

export default getPlaceDetails
